import axios, { type AxiosRequestConfig, type AxiosResponse, type Method } from 'axios';

// const API_URL = 'http://localhost:8888/despachos-app/api';
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8888/despachos-app/api';
const BASE_PATH = import.meta.env.BASE_URL || '/';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config: any) => {
  const token = localStorage.getItem('appToken');
  if (token) {
    if (!config.headers) config.headers = {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    if (response.data && [
      'not-able-to-get-user-configuration',
      'invalid-user-access',
      'invalid-user',
    ].includes(response.data.token)) {
      handleSessionExpired();
      return Promise.reject(response.data);
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      handleSessionExpired();
    }
    return Promise.reject(error);
  }
);

const handleSessionExpired = () => {
  localStorage.removeItem('appToken');
  const currentPath = window.location.pathname.replace(BASE_PATH, '/') + window.location.search;
  const loginUrl = `${BASE_PATH}login?redirect=${encodeURIComponent(currentPath)}`.replace(/\/+/g, '/');
  window.location.href = loginUrl;
};

type Data = Record<string, any>;

export async function ajax<TResponse = any>(
  method: Method,
  url: string,
  data?: Data,
  config?: AxiosRequestConfig
): Promise<TResponse> {
  try {
    let response: AxiosResponse<TResponse>;
    const finalConfig = { ...config };

    if (data instanceof FormData) {
      finalConfig.headers = {
        ...finalConfig.headers,
        'Content-Type': 'multipart/form-data',
      };
    }

    switch (method.toUpperCase()) {
      case 'GET':
        response = await api.get<TResponse>(url, { params: data, ...finalConfig });
        break;

      case 'DELETE':
        response = await api.delete<TResponse>(url, { params: data, ...config });
        break;

      case 'POST':
        response = await api.post<TResponse>(url, data, finalConfig);
        break;

      case 'PUT':
        response = await api.put<TResponse>(url, data, finalConfig);
        break;

      case 'PATCH':
        response = await api.patch<TResponse>(url, data, config);
        break;

      default:
        throw new Error(`Método HTTP no soportado: ${method}`);
    }

    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      console.error('Error en AJAX:', error);
      throw error.response?.data || error;
    }
    throw error;
  }
}
